function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.25 0.25)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.331,0A27.331,27.331,0,1,0,54.662,27.331,27.361,27.361,0,0,0,27.331,0Zm0,50.428a23.1,23.1,0,1,1,23.1-23.1A23.124,23.124,0,0,1,27.331,50.428Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.629 14.438)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M160.309,145.823h-8.468v-8.468a2.117,2.117,0,0,0-4.234,0v8.468h-8.468a2.117,2.117,0,1,0,0,4.234h8.468v8.468a2.117,2.117,0,1,0,4.234,0v-8.468h8.468a2.117,2.117,0,0,0,0-4.234Z",
  transform: "translate(-137.022 -135.238)"
})));

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55.162,
    height: 55.162,
    viewBox: "0 0 55.162 55.162",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.984d6e12.svg";
export { ForwardRef as ReactComponent };